import { clsx } from 'clsx';
import * as styles from './styles.css';
import * as React from 'react';
import { PROMO_ICON } from '../constants/icons';

export function MortgageIcon() {
  return (
    <div className={clsx(styles['container'], styles['ipoteka'])}>
      <img src={PROMO_ICON.get('mortgage')} className={styles['icon-img']} />
    </div>
  );
}
